import React, { useState } from 'react';
import { Navbar, Container, Nav, Dropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { defaultTheme, useTheme } from '../../context/PortalThemeContext';

const LoggedInTopBar = ({ customer, onLogout }) => {
  const theme = useTheme();

  const navigate = useNavigate();

  const [showDropdown, setShowDropdown] = useState(false);

  if (!customer) return null;

  const initials = customer?.name
    ? customer.name.split(' ').map(n => n[0]).join('').toUpperCase()
    : customer.email[0].toUpperCase();

  return (
    <Navbar
      style={{
        background: `linear-gradient(90deg, ${theme.accentColor} 0%, #f8f9fa 100%)`,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.03)',
        paddingTop: '0.85rem',
        paddingBottom: '0.85rem',
        position: 'sticky',
        top: 0,
        zIndex: 1000,
      }}
    >
      <Container
        fluid
        className="px-4 d-flex justify-content-between align-items-center"
      >
        {/* Back link */}
        <Nav.Link
          href="#"
          style={{
            fontWeight: 500,
            color: theme.textDark,
            textDecoration: 'none',
            fontSize: '15px',
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
          }}
        >
        </Nav.Link>

        {/* Center logo with glow */}
        <div
          style={{
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img
            src={theme.imageSrc || defaultTheme.imageSrc}
            alt="Brand Logo"
            style={{
              height: '48px',
              maxWidth: '240px',
              objectFit: 'contain',
            }}
          />
        </div>

        {/* User info */}
        <div className="d-flex align-items-center gap-3">
          <div className="text-end hide-on-mobile">
            <div style={{
              fontSize: '14px', fontWeight: 600, color: theme.textDark,
            }}>
              {customer.name || customer.email}
            </div>
            <div style={{ fontSize: '12px', color: theme.textLight }}>Logged in</div>
          </div>

          {/* Avatar Dropdown */}
          <Dropdown align="end" show={showDropdown} onToggle={setShowDropdown}>
            <Dropdown.Toggle
              id="dropdown-avatar"
              variant="light"
              style={{
                backgroundColor: theme.accentColor,
                color: theme.buttonTextColor,
                borderRadius: '9999px',
                width: '36px',
                height: '36px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 600,
                fontSize: '14px',
                border: 'none',
                boxShadow: '0 0 0 2px #fff',
                padding: 0,
              }}
            >
              {initials}
            </Dropdown.Toggle>

            <Dropdown.Menu style={{ minWidth: '180px' }}>
              <Dropdown.Item onClick={() => navigate('/orders')}>
                View Orders
              </Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item onClick={onLogout}>
                Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </Container>
    </Navbar>
  );
};

export default LoggedInTopBar;
